import { esInstagramPalettes } from "../../../../Posts/05-tematicas/05-instagram/instagramPalettes.js";
import * as React from 'react';
export default {
  esInstagramPalettes,
  React
};